import ListSubheader, { ListSubheaderProps } from '@material-ui/core/ListSubheader';

export type DSListSubheaderProps = ListSubheaderProps;

export const DSListSubheader = ListSubheader;
